import { atom } from 'jotai';

export const fullscreenFeedIdAtom = atom<string | null>(null);
